module.exports = __webpack_public_path__ + "img/CompScope_Mag_1_Focus_2.cd290ea0.png";